import axios from 'axios';
import { api_url, mg_token_name } from '../config/Params.constant';
import storage from './Storage';

class StripeService {

    create(data) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.post(`${api_url}/stripe`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    cancel(id) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.get(`${api_url}/stripe/cancel/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    view(id) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.get(`${api_url}/stripe/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }


    viewAll() {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.get(`${api_url}/stripe`, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    filterAll(data) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.post(`${api_url}/stripe/filter`,data , {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }



}

export default new StripeService()